export default __webpack_public_path__ + "static/media/download.48bb43e2.svg";